module.exports = __webpack_public_path__ + "media/images/flags/64/Egypt-bb329bb7033829e9e59324244b22b8a9.png";